import Vue from 'vue';

import Confirm from '../../components/confirmation/confirm.vue';


export default Vue.extend({
  components: {
    Confirm
  },

    data: () => ({
      allSubject : [],
      scoreItem: [
        {data:'Grade A(71-100)',value : '71 - 100'},
        {data : 'Grade B(51-70)',value : '51 - 70'},
        {data : 'Grade C(31-50)',value : '31 - 50'},
        {data : 'Grade D(<=30)',value : '0-30'}
      ],
      sRange:'',
      testName :'',
      noOftests : [{
          'testValue' : '0 - 10',
        },
        {
          'testValue' : '11 - 30',
        },
        {
          'testValue' : '31 - 50',
        },
        {
          'testValue' : '51 - 70',
        },
        {
          'testValue' : '70 Above',
        }
      ],
      retrievedObject : {},
      result : [],  
      id : 0,
      allSelected : false,
      items: ['Invite'],
      snackbar:false,
      showMessage:'',
      selectData :[],
      length : 0,
      dialog : false,
      dataLoading : false,
      showData : '',
      dataWeight :  true,
      messageDialg : false,
    }),
    
    created(){
     
      this.getJoblength();
      this.getallSubject();
      // this.search_result();
      // this.retrievedObject = JSON.parse(localStorage.getItem('searchData'));
      // console.log('retrievedObject: ', this.retrievedObject.id);
      // this.id = this.retrievedObject.id;
      // this.sRange = this.retrievedObject.score; 
      // this.testName = this.retrievedObject.test;
      localStorage.removeItem('id');
      localStorage.removeItem('all_id');
        
    },
    
    methods : {
      //get subject list
      async getallSubject(){
        let token =  localStorage.getItem("jwt");
        console.log(token);
        this.userId= localStorage.getItem("userId");
        if (token && this.userId) {   
          const auth ={
            headers: {authorization: token}
          };
          let resultSubject = await this.$http.get('/job/fetchSubject',auth)
          console.log(resultSubject);
          if (resultSubject.status === 200 && resultSubject.data.message) {
            this.allSubject = resultSubject.data.subject;
          }
        }
      },

      async getJoblength(){
        let token =  localStorage.getItem("jwt");
        let userId =  localStorage.getItem("userId");
        //this.dataLoading = true;
        if (token && userId) { 
          const auth = {
            headers: {authorization: token} 
          }  
          let resp = await this.$http.get('job/fetchJobsByRecruiter/'+userId, auth)
          console.log(resp);
          if(resp.status === 200 && resp.data.message === "Jobs found"){
            this.length = resp.data.jobs.length;
            console.log("sd",this.length);
          }
        }
      },
      // selectSubejct(event){
      //   console.log("event",event);
      //   console.log("event",event.length);
      //   if (event.length>1) {
      //     this.dataWeight = false;
      //   } else {
      //     this.dataWeight = true;
      //   }
      // },

      async search_result(){
        let token =  localStorage.getItem("jwt");
        this.userId= localStorage.getItem("userId");
        if (token && this.userId) {   
          const auth ={
            headers: {authorization: token}
          };
          let newarray = [];
          if (this.id==[]) {
            console.log("dfd",this.id);
            this.snackbar = true;
            this.showMessage = 'Please select subject.'
          } else {
            console.log(this.id);
            console.log("num",this.sRange);
            console.log("testName",this.testName);
            if (this.sRange =='') {
              this.sRange = '0-100'
            } 

            if (this.testName == '') {
              this.testName = '0-100'
            } else if (this.testName == '70 Above') {
              this.testName = '71-100'
            }
            let arr = this.sRange.split("-"); console.log("arr",arr);
            let arr2 = this.testName.split("-"); console.log("arr",arr);
            this.result = [];
            this.dataLoading = true;
            
            await this.$http.post('/student/filterStudentsByGrade',{
              subject_id: this.id,
              min_average_marks: parseInt(arr[0]),
              max_average_marks: parseInt(arr[1]),
              min_number_of_exam_attempted: parseInt(arr2[0]),
              max_number_of_exam_attempted: parseInt(arr2[1])
            },auth).then(response => {
              console.log(response);
              if (response.status === 200){
                if (response.data.message === "Student not found") {
                  this.showData= true;
                } else {
                  this.showData= false;
                  this.result = response.data.students;
                  console.log(response.data);
                  console.log(this.result.length);
                
                  for (let i = 0; i < this.result.length; i++) {
                    for (let j = 0; j < this.result[i].subjectwise_details.length; j++) {
                        if (this.result[i].subjectwise_details[j].average_marks>70){
                          this.result[i].subjectwise_details[j].average_marks = 'Grade A'
                        }else if (this.result[i].subjectwise_details[j].average_marks>50){
                          this.result[i].subjectwise_details[j].average_marks = 'Grade B'
                        }else if (this.result[i].subjectwise_details[j].average_marks>30){
                          this.result[i].subjectwise_details[j].average_marks = 'Grade C'
                        }else{
                          this.result[i].subjectwise_details[j].average_marks = 'Grade D'
                        }
                      }
                    }
              }
            }
            })
          }
          this.dataLoading = false;
        }
      },
      

      viewCandidate(sid){
        // this.$router.push("/candidate_details/"+sid);
        this.$router.push({ name: 'candidate_details', params: { id: sid } })
      },

      // onCheckboxClicked(id,email){
      //   console.log("email",email);
      // },
      // ********************  single candidaye invite **************//
      async invite_job(id){
        if (this.length == 0) {
          this.dialog = true;
        }      
        else{
          console.log("email", id)
          localStorage.setItem("id", id);
          this.$router.push('/search_job');
        }
      },

      selectAll(){
        this.allSelected = !this.allSelected;
        this.selectData = [];
        if (this.allSelected) {
            for (let i = 0; i < this.result.length; i++) {
              this.selectData.push(this.result[i].user_id)
            }
        }
        console.log(this.selectData);
      },

      select(){
        this.allSelected = false;
      },
   
      menuActionClick(item){
        if (item=="Invite") {
          if (this.length == 0) {
            this.dialog = true;
          }else if (this.selectData.length == 0) {
            this.messageDialg = true;
          }else{
            console.log("jv",this.selectData);
            localStorage.setItem("all_id", JSON.stringify(this.selectData));
            // this.$router.push('/search_job')
            this.$router.push({ name: 'search_job' })
          }
        } 
      },

      backPage() {
        window.history.back()
      },
      
      agree(){
        // this.$router.push('/job-application');
        this.$router.push({ name: 'job-application'})
      },
    }
})




